module.exports = __webpack_public_path__ + "img/activities-8.1ef54a57.jpg";